import type { Stacklet } from '@/entities/stacklet';
import request from '@/shared/api/request';

export const getStacklet = (id: number): Promise<{ stacklet: Stacklet }> =>
  request({
    url: `/stacklets/${id}/`,
  });
